module.exports = __webpack_public_path__ + "static/media/arrow-top.9ccef350.png";